var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1A2734",
  fillOpacity: .351,
  fillRule: "evenodd",
  d: "M14.58 2.049L13.167.635 7.562 6.239 1.958.635.544 2.049 6.15 7.653.544 13.257l1.414 1.414 5.604-5.604 5.605 5.604 1.413-1.414-5.604-5.604z"
})));
export default __webpack_public_path__ + "teg/media/close.351d3df6.svg";
export { SvgComponent as ReactComponent };